import React          from 'react';
import { Meteor }	  from 'meteor/meteor';
import classnames     from 'classnames';
import connectField   from 'uniforms/connectField';
import filterDOMProps from 'uniforms/filterDOMProps';
import joinName       from 'uniforms/joinName';

import DynamicListAddField from './DynamicListAddField';
import ListItemField from './ListItemField';

class DynamicList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			subscription: Meteor.subscribe(this.props.subscription, () => this.forceUpdate()),
		};
	}

	componentWillUnmount() {
		this.state.subscription.stop();
	}

	resources() {
		return this.props.options
			.find(Object.assign(this.props.filters, { _id: { $nin: this.props.value } }))
			.fetch();
	}

	render() {
		return (
			<div
				className={classnames('panel panel-default dynamic-list-field', {'panel-danger': this.props.error}, this.props.className)}
				{...filterDOMProps(this.props)}
			>
				<div className="panel-body">
					{this.props.label && (
						<div className={classnames('panel-heading', {'has-error': this.props.error})}>
							<label className="control-label">
								{this.props.label}&nbsp;:
							</label><br/>

							<DynamicListAddField name={`${this.props.name}.$`} initialCount={this.props.initialCount} addIcon={this.props.addIcon} valueList={this.resources()} />

							{!!(this.props.errorMessage && this.props.showInlineError) && (
								<span className="help-block">
									{this.props.errorMessage}
								</span>
							)}
						</div>
					)}
					
					{this.props.value && this.state.subscription.ready() &&
						this.props.value.map((item, index) =>

								<ListItemField
									key={index}
									label={null}
									children={this.props.options.findOne({'_id': item}) ? (<span>{this.props.options.findOne({'_id': item}).username}</span>) : (!this.props.options.findOne({'_id': item}) && <span>Utilisateur supprimé</span>)}
									name={joinName(this.props.name, index)}
									removeIcon={this.props.removeIcon}
									{...this.props.itemProps}
								/>
						) }
				</div>
			</div>
		);
	}
}

export default connectField(DynamicList, {includeInChain: false});



/** WEBPACK FOOTER **
 ** ./src/universal/components/fields/dynamicListField.js
 **/